import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Toggle } from '../../../../../../../../../../CommonComponents/OPL/Toggle/Toggle';

interface Props {
  isInsurance?: boolean;
}

export const ShowAccountToggle = ({ isInsurance }: Props) => {
  const fieldPrefix = isInsurance ? '' : 'bankAccount.';

  const formBag = useFormContext();

  const handleOnChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    formBag.setValue(`${fieldPrefix}ShowAccount`, evt.target.checked);

    if (!evt.target.checked) {
      formBag.setValue(`${fieldPrefix}SyncAccountValueEnabled`, false);
      formBag.setValue(`${fieldPrefix}SyncAssetAllocationEnabled`, false);
      formBag.setValue(`${fieldPrefix}SyncMonthlyContributionEnabled`, false);
      formBag.setValue(`${fieldPrefix}SyncTransactionsEnabled`, false);
    }
  };

  return (
    <Toggle
      {...formBag.register(`${fieldPrefix}ShowAccount`)}
      onChange={handleOnChange}
      helperText="If disabled, the account will be excluded from the Accounts list and the Financial Plan."
      size="small"
    >
      Show Account
    </Toggle>
  );
};
